import { FC, useEffect, useState } from "react";

import { Text, Stack, StyleProps, Link, UnorderedList } from "@chakra-ui/react";
import ReactMarkdown from "react-markdown";

import common from "content/common/common.json";
import landing from "content/landing/landing-config.json";
import otherProjects from "content/other-projects/other-projects-config.json";
import featuredWork from "content/featured-work/featured-work-config.json"

import about from "content/about/about-config.json";

import LandingMd from "content/landing/landing.md";
import AboutMd from "content/about/about.md";

export const configs = {
    common,
    landing,
    featuredWork, 
    otherProjects,
    about,
};

interface State {
    landing: string;
    about: string;
}

export enum MarkdownFile {
    Landing = "landing",
    About = "about",
}

const Mapper = {
    [MarkdownFile.Landing]: LandingMd,
    [MarkdownFile.About]: AboutMd,
};

export const useContent = (fileName: MarkdownFile) => {
    const [data, setData] = useState<State>({ landing: "", about: "" });

    useEffect(() => {
        fetch(Mapper[fileName])
            .then((res) => res.text())
            .then((text) => setData((data) => ({ ...data, [fileName]: text })));
    }, [fileName]);

    return data;
};

interface Props extends StyleProps {
    children?: string;
}

export const Content: FC<Props> = ({ children, ...rest }) => {
    return (
  
   
 


        <Stack spacing="4"  w="full" overflowX="hidden">
            <ReactMarkdown
                components={{
                    p: ({ node, ...props }) => <Text overflowWrap="break-word" wordBreak="break-word" {...rest} {...props} />,
                    a: ({ node, ...props }) => (
                        <Link overflowWrap="break-word" color="primary.200" href={props.href} target="_blank"  {...props} />
                    ),
                    ul: ({ node, ...props }) => {
                        const { ordered, ...rest } = props;

                        return (
                            <UnorderedList
                                {...rest}
                                data-aos="fade"
                                listStylePosition="inside"
                                display={{ base: "block", md: "grid" }}
                                gridTemplateColumns="repeat(2, 1fr)"
                                listStyleType="'‣ '"
                                fontWeight="600"
                            />
                        );
                    },
                    li: ({ node, ...props }) => {
                        const { ordered, ...rest } = props;

                        return <li data-aos="flip-up" data-aos-delay={props.index * 100 + 400} {...rest} />;
                    },
                }}
            >
                {children as string}
            </ReactMarkdown>
        </Stack>
    );
};
